import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import { Toaster } from 'src/utils/helper/toaster'
import i18n from 'src/assets/i18n/i18n'
const { t } = i18n().global

export default {
  namespaced: true,

  state () {
    return {
      users: [],
      foundryDetails: {},
      allFoundries: [],
      isLoading: true,
      isFoundryAvailable: true,
      isSuccess: false,
      isFoundryModal: false,
      avScanStatus: '',
      avScanStatusName: ''
    }
  },

  getters: {
    list: state => {
      return state.users
    },
    foundryDetails: state => {
      return state.foundryDetails
    },
    allfoundries: state => {
      return state.allFoundries
    },
    spinnerStatus: state => {
      return state.isLoading
    },
    uniqueFoundryFlag: state => {
      return state.isFoundryAvailable
    },
    isSuccessFull: state => {
      return state.isSuccess
    },
    getFoundryModal: state => {
      return state.isFoundryModal
    },
    getAvScanStatus: state => {
      return {
        status: state.avScanStatus,
        name: state.avScanStatusName
      }
    }
  },

  mutations: {
    add (state, users) {
      state.users = users
    },
    clear (state) {
      state.users = []
    },
    clearAllFoundries (state) {
      state.allFoundries = []
    },
    setFoundryDetail (state, foundryData = {}) {
      state.foundryDetails = foundryData
    },
    setSpinnerStatus (state) {
      state.isLoading = false
    },
    resetFoundryRecords (state) {
      state.isLoading = true
      state.allFoundries = []
    },
    setAllFoundries (state, foundries) {
      state.allFoundries = foundries
    },
    isUniqueFoundry (state, flag) {
      state.isFoundryAvailable = flag
    },
    setIsSuccess (state) {
      state.isSuccess = true
    },
    unsetIsSuccess (state) {
      state.isSuccess = false
    },
    setFoundryModal (state) {
      state.isFoundryModal = true
    },
    setAvScanStatus (state, status) {
      state.avScanStatus = status.status;
      state.avScanStatusName = status.name;
    }
  },

  actions: {
    getSupportUsers({ commit }) {
      return new Promise((resolve, reject) => {
        Api.Users.getFoundrySupportUsers()
          .then((response) => {
            commit('add', (response?.data?.collection || {}))
            resolve(response)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getAllFoundries({ commit }, options = {}) {
      return new Promise((resolve, reject) => {
        commit('clearAllFoundries')
        Api.Users.getFoundries(options.foundryName)
          .then((response) => {
            // Filtering the foundries response when name key has '' OR empty value is there
            const foundryCollection = response?.data?.foundries?.filter(value => value.name !== '')
            // Setting the foundries in getter
            commit('setAllFoundries', foundryCollection)
            commit('setSpinnerStatus')
            resolve(foundryCollection)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getFoundryById({ commit, state }, options) {
      options = {
        foundryId: null,
        force: false,
        ...options
      }
      return new Promise((resolve) => {
        Api.Foundry.getFoundryById(options.foundryId)
          .then(response => {
            const foundryDetails = typeof response?.data?.id === 'string' ? response.data : undefined
            commit('setFoundryDetail', foundryDetails)
            commit('setSpinnerStatus')
            resolve(foundryDetails)
          })
          .catch(error => {
            commit('errors/add', Errors.create(error))
            resolve(error)
          })
      })
    },

    deleteImageProfile({ commit }, options) {
      return new Promise((resolve, reject) => {
        Api.Foundry.deleteFoundryLogo(options.logoId, options.foundryId)
          .then((response) => {
            return resolve(response.data)
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            return reject(err)
          })
      })
    },

    UploadFoundryImage({dispatch, commit }, options) {
      return new Promise((resolve, reject) => {
        const { file, foundryId, priority, md5 } = options[0];
        const foundryImageRequest = {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          md5Checksum: md5,
          priority: priority.toString()
        };
        return Api.Foundry.uploadFoundryLogo(foundryId, foundryImageRequest)
          .then(async (response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            let err = Errors.create(error)
            return reject(err)
          })
      })
    },

    updateFoundryById ({ commit, state }, options) {
      options = {
        foundryId: null,
        foundryDetail: null,
        force: false,
        ...options
      }
      return new Promise((resolve) => {
        Api.Foundry.updateFoundryDetail(options.foundryId, options.foundryDetail)
          .then(response => {
            const foundryDetails = typeof response?.data?.id === 'string' ? response.data : undefined
            commit('setFoundryDetail', foundryDetails)
            commit('setSpinnerStatus')
            return resolve(response)
          })
          .catch(error => {
            commit('errors/add', Errors.create(error))
            resolve(error)
          })
      })
    },
    isFoundryUnique({ commit, state }, foundryName) {
      return new Promise((resolve) => {
        Api.Foundry.checkisFoundryUnique(foundryName)
          .then(response => {
            commit('isUniqueFoundry', response.data.isFoundryUnique)
            resolve(response)
          })
          .catch(error => {
            commit('errors/add', Errors.create(error))
            resolve(error)
          })
      })
    },
    clear({ commit }) {
      commit('clear')
    },
    clearAllFoundries({ commit }) {
      commit('clearAllFoundries')
    },
    checkAvStatus({ dispatch, commit }, foundryId) {
      commit('setAvScanStatus', { status: 'scanning' });
      return new Promise((resolve) => {
        Api.Asset.getAssetsAvStatus(foundryId, 'foundry')
          .then((res) => {
            
            const avStatuses = res.data.assets.map(asset => asset.avStatus);
            if (avStatuses.includes('false')) {
              commit('setAvScanStatus', { status: false, name: res.data.assets.find(asset => asset.avStatus === 'false').fileName});
              Toaster.notifyMalwareWarning(t('malwareScan.toastMessage'))
            } else if (avStatuses.includes('')) {
              commit('setAvScanStatus', { status: 'scanning' });
            } else if (avStatuses.every(status => status === 'true')) {
              commit('setAvScanStatus', { status: true });
            }
            return resolve(res);
          })
          .catch((err) => {
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
